const styles = theme => ({
  buttonsStyle: {
    flexDirection: 'row',
    width: '100%',
    display: 'flex',
    gap: '5px',
    justifyContent: 'flex-end',
    margin: '8px 0px',
  },
  noticeButtonsStyle: {
    flexDirection: 'row',
    width: '100%',
    display: 'flex',
    gap: '12px',
    justifyContent: 'center',
    margin: '8px 0px',
  },
  noticeButton: {
    minWidth: '100px',
    height: '40px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 500,
  },
})
export default styles
